import { makeValuesPredicate } from '@sgme/fp';
import { TooltipProps } from '@sgme/ui';
import { BlotterPanelDocumentStatus } from 'epic/common-form/Documentation';
import { DocumentType } from 'models/documents/DocumentType';

type DocumentTooltipProps = {
  color: TooltipProps['color'];
  intlKey: string;
};

export const isDocumentValidated = makeValuesPredicate([
  'Validated',
  'Validated - error on sending to Jedeai',
  'Validated - error on sending to Repository',
]);

export const isDocumentGenerationFailed = makeValuesPredicate(['Generation failed']);

export function getDocumentTooltipProps(
  status: string | undefined,
  type: DocumentType,
  intlPrefix: string,
): Partial<DocumentTooltipProps> {
  switch (status) {
    case 'Validated':
    case 'Validated - error on sending to Jedeai':
    case 'Validated - error on sending to Repository':
    case undefined:
      return {};
    case 'Generation failed':
      return {
        color: 'danger',
        intlKey: `${intlPrefix}.document.${type}.status.error`,
      };
    default:
      return {
        color: 'warning',
        intlKey: `${intlPrefix}.document.${type}.status.not-validated`,
      };
  }
}

export function getDocumentStatusIcon(status: BlotterPanelDocumentStatus | undefined): string | undefined {
  switch (status) {
    case 'Validated':
    case 'Validated - error on sending to Jedeai':
    case 'Validated - error on sending to Repository':
    case undefined:
      return undefined;
    case 'Generation failed':
      return 'block';
    default:
      return 'error_outline';
  }
}
